import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
// User defined lang
import enLocale from './en'
import itLocale from './it'
import frLocale from './fr'
// import zhLocale from './zh'

const messages = {
  en: {
    ...enLocale
  },  
  it: {
    ...itLocale
  },  
  fr: {
    ...frLocale
  }
}
// console.dir(messages)

// const getLocale = () => {
//   const cookieLanguage = sessionStorage.getItem('language')
//   if (cookieLanguage) {
//     return cookieLanguage
//   }
//   const language = navigator.language.toLowerCase()
//   const locales = Object.keys(messages)
//   for (const locale of locales) {
//     if (language.indexOf(locale) > -1) {
//       return locale
//     }
//   }
//   return 'it-IT'
// }



const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: 'it', // set locale
  fallbackLocale: 'it', // set fallback locale
  messages: messages,
})

// console.log(getLocale())
// console.log(i18n)

// export default i18n
export default (app: App<Element>): void => {
  app.use(i18n)
}
